import React from 'react';
import { MoonStarIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../data/contact';
interface HeaderProps {
  lockup: string;
}
export function Header({
  lockup
}: HeaderProps) {
  return <header className="sticky top-0 z-40 border-b border-silver/10 bg-carbon/85 backdrop-blur-md" data-id="element-73" data-mp="2il7ne1i8c58k">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-5 sm:h-20 sm:px-8" data-id="element-74" data-mp="2nku089u5bjgu">
        <a href="#inicio" className="flex items-center gap-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft" data-id="element-75" data-mp="2rl48jt5eulyv">
          <MoonStarIcon className="h-5 w-5 shrink-0 text-accent-soft" aria-hidden="true" data-id="element-76" data-mp="31c8l6m7m5uqj" />
          <span className="font-display text-[0.72rem] font-medium uppercase leading-tight tracking-[0.22em] text-frost sm:text-sm sm:tracking-[0.28em]" data-id="element-77" data-mp="36bbg3dtvqkks">
            {lockup}
          </span>
        </a>

        <nav aria-label="Navegación principal" className="flex items-center gap-5 sm:gap-8" data-id="element-78" data-mp="3fcrqhlkp2mp0">
          <a href="#inicio" className="text-[0.7rem] font-medium uppercase tracking-[0.22em] text-silver transition-colors hover:text-frost focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft" data-id="element-79" data-mp="2wl4dkkvppwdk">
            Inicio
          </a>
          <a href={contact.phoneHref} className="hidden items-center gap-2 rounded-full border border-silver/30 px-5 py-2.5 text-[0.7rem] font-medium uppercase tracking-[0.18em] text-frost transition-colors hover:border-silver/70 hover:bg-silver/5 sm:inline-flex" data-id="element-80" data-mp="2hntxszc1e4c1">
            <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-81" data-mp="35l0xyab2k92t" />
            Llamar ahora
          </a>
        </nav>
      </div>
    </header>;
}